export function transform<T>(fn: null, data: T): T;
// eslint-disable-next-line no-redeclare
export function transform<T, R>(fn: (x: T) => R, data: T): R;
// eslint-disable-next-line no-redeclare
export function transform<T, R>(fn: (x: T) => R | null, data: T): R | T {
    if (fn != null) {
        return fn(data);
    }
    return data;
}
